export const registerPageTranslations = {
    en: {
        welcome_title: 'Welcome to Hoowlr',
        welcome_description: 'Create your profile with your email, phone, and a secure password to start your journey.',
        create_account_title: 'Register',
        create_account_subtitle: 'Enter your details to register',
        email_label: 'Email',
        email_placeholder: 'Enter your email',
        email_required: 'Email is required',
        email_invalid: 'Invalid email format',
        phone_label: 'Phone number',
        phone_placeholder: 'Enter your phone number',
        phone_required: 'Phone number is required',
        phone_invalid: 'Phone number must be 7-15 digits',
        password_label: 'Password',
        password_placeholder: 'Enter your password',
        password_required: 'Password is required',
        password_min_length: 'Password must be at least 8 characters',
        password_uppercase: 'Password must include at least 1 uppercase letter',
        password_lowercase: 'Password must include at least 1 lowercase letter',
        password_special: 'Password must include at least 1 special character',
        continue_button: 'Continue',
        already_account: 'Already have an account?',
        sign_in_link: 'Login',
        error_title: 'Error',
        error_message: 'Failed to register. Please try again.',
        error_close_button: 'Close',
        language_select_label: 'Select Language',
        language_en: 'English',
        language_de: 'German',
        language_hr: 'Croatian',
        footer_copyright: '© Hoowlr 2026, All rights reserved',
    },
    de: {
        welcome_title: 'Willkommen bei Hoowlr',
        welcome_description: 'Erstellen Sie Ihr Profil mit Ihrer E-Mail, Telefonnummer und einem sicheren Passwort, um Ihre Reise zu beginnen.',
        create_account_title: 'Konto erstellen',
        create_account_subtitle: 'Geben Sie Ihre Daten ein, um sich zu registrieren',
        email_label: 'E-Mail',
        email_placeholder: 'Geben Sie Ihre E-Mail ein',
        email_required: 'E-Mail ist erforderlich',
        email_invalid: 'Ungültiges E-Mail-Format',
        phone_label: 'Telefonnummer',
        phone_placeholder: 'Geben Sie Ihre Telefonnummer ein',
        phone_required: 'Telefonnummer ist erforderlich',
        phone_invalid: 'Telefonnummer muss 7-15 Ziffern haben',
        password_label: 'Passwort',
        password_placeholder: 'Geben Sie Ihr Passwort ein',
        password_required: 'Passwort ist erforderlich',
        password_min_length: 'Passwort muss mindestens 8 Zeichen lang sein',
        password_uppercase: 'Passwort muss mindestens 1 Großbuchstaben enthalten',
        password_lowercase: 'Passwort muss mindestens 1 Kleinbuchstaben enthalten',
        password_special: 'Passwort muss mindestens 1 Sonderzeichen enthalten',
        continue_button: 'Weiter',
        already_account: 'Haben Sie bereits ein Konto?',
        sign_in_link: 'Anmelden',
        error_title: 'Fehler',
        error_message: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        error_close_button: 'Schließen',
        language_select_label: 'Sprache wählen',
        language_en: 'Englisch',
        language_de: 'Deutsch',
        language_hr: 'Kroatisch',
        footer_copyright: '© Hoowlr 2026, Alle Rechte vorbehalten',
    },
 hr: {
    welcome_title: "Dobrodošli u Hoowlr",
    welcome_description: "Kreirajte svoj profil s e-mailom, telefonskim brojem i sigurnom lozinkom da započnete svoju avanturu.",
    create_account_title: "Kreiraj račun",
    create_account_subtitle: "Unesite svoje podatke za registraciju",
    email_label: "E-pošta",
    email_placeholder: "Unesite svoju e-poštu",
    email_required: "E-pošta je obavezna",
    email_invalid: "Neispravan format e-pošte",
    phone_label: "Telefonski broj",
    phone_placeholder: "Unesite svoj telefonski broj",
    phone_required: "Telefonski broj je obavezan",
    phone_invalid: "Telefonski broj mora sadržavati između 7 i 15 znamenki",
    password_label: "Lozinka",
    password_placeholder: "Unesite svoju lozinku",
    password_required: "Lozinka je obavezna",
    password_min_length: "Lozinka mora imati najmanje 8 znakova",
    password_uppercase: "Lozinka mora sadržavati najmanje jedno veliko slovo",
    password_lowercase: "Lozinka mora sadržavati najmanje jedno malo slovo",
    password_special: "Lozinka mora sadržavati najmanje jedan poseban znak",
    continue_button: "Nastavi",
    already_account: "Već imate račun?",
    sign_in_link: "Prijavi se",
    error_title: "Greška",
    error_message: "Registracija nije uspjela. Molimo pokušajte ponovo.",
    error_close_button: "Zatvori",
    language_select_label: "Odaberite jezik",
    language_en: "Engleski",
    language_de: "Njemački",
    language_hr: "Hrvatski",
    footer_copyright: "© Hoowlr 2026, Sva prava pridržana",
}

  };